import Axios, { AxiosResponse } from 'axios';
import { buildBaseUrl, teamRESTUrl } from 'lib/utils';
import getConfig from 'next/config';

const { publicRuntimeConfig: { genericRESTUrl } } = getConfig();

export const createDefaultPack = async (identifier: string): Promise<AxiosResponse> => {
  try {
    const team = teamRESTUrl(identifier);
    const url = buildBaseUrl(team, `${genericRESTUrl}/v1/packs/init`);

    return await Axios.post(url, {}, { withCredentials: true })
  } catch (err){
    console.error(err)
  }
}
